<template>
  <div class="ai-math-course-bar">
    <div v-if="list.length > 0" ref="list" class="list">
      <template v-if="list.length > 3">
        <div class="nav nav-left" @click="navLeft" v-if="navLeftIndex > 0">
          <i class="el-icon-arrow-left" />
        </div>
        <div class="nav nav-right" @click="navRight" v-if="navLeftIndex < maxNavLeftIndex">
          <i class="el-icon-arrow-right" />
        </div>
      </template>
      <div style="overflow: hidden">
        <div
          class="item-container clearfix"
          :style="{
            width: `${list.length * 300}px`,
            marginLeft: `${-navLeftIndex * 2 * 300}px`,
          }"
        >
          <div
            class="item"
            :class="{
              selected: index == currentIndex,
            }"
            v-for="(item, index) in list"
            :key="item.periodsId"
            @click="handlerCourseClick(index)"
          >
            <span v-if="item.is_last_time_viewed === 1" class="last-viewed">上次学到</span>
            <!-- <img
              v-if="item.valid_status != 1"
              class="expire"
              src="@/modules/stu/images/expire@2x.png"
            /> -->
            <div class="content">
              <div class="title">
                <span class="title-tag">数学</span>
                <span class="title-cont multi-line-1" :title="item.title">
                  {{ item.periodsName }}
                </span>
              </div>
              <div class="sub-title">
                <!-- <span class="sub-title-content"> -->
                <!-- {{ item.courseName }} -->
                <el-tooltip effect="dark" :content="item.courseName" placement="top">
                  <span class="sub-title-content">{{ item.courseName }} </span>
                </el-tooltip>
                <!-- </span> -->
                <span class="line"></span>
                <span class="date">{{ showDate }}</span>
              </div>
              <!-- <div class="valid">
                <span v-highlight="item.valid_date_txt"></span>
              </div> -->
              <div class="task-list-entry" @click.stop="handleTaskList(item.periodsId, item)">
                <span>任务列表</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="8"
                  height="8"
                  viewBox="0 0 8 8"
                  fill="none"
                >
                  <mask
                    id="mask0_4969_2381"
                    style="mask-type: alpha"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="8"
                    height="8"
                  >
                    <rect width="8" height="8" fill="#D9D9D9" />
                  </mask>
                  <g mask="url(#mask0_4969_2381)">
                    <path
                      d="M3.3335 2L5.09779 3.7643C5.22797 3.89447 5.22797 4.10553 5.09779 4.2357L3.3335 6"
                      stroke="#0060D1"
                      stroke-linecap="round"
                    />
                  </g>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="clear: both"></div>
    </div>
    <TaskListDialog :show.sync="showTaskList" :periodsId="periodsId" />
  </div>
</template>

<script>
import TaskListDialog from './TaskListDialog.vue';

export default {
  name: 'CourseBar',
  components: {
    TaskListDialog,
  },
  props: {
    initSelectedIndex: {
      type: Number,
      default: 0,
    },
    list: [],
    showDate: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      currentIndex: this.initSelectedIndex,
      navLeftIndex: 0,
      showTaskList: false,
      periodsId: 0,
    };
  },
  computed: {
    maxNavLeftIndex() {
      return Math.max(0, Math.ceil((this.list.length - 3) / 2));
    },
  },
  mounted() {
    // 初始化时，计算需要滚动的位置
    this.navLeftIndex = Math.min(
      this.maxNavLeftIndex,
      this.initSelectedIndex % 2 === 0
        ? this.initSelectedIndex / 2
        : (this.initSelectedIndex - 1) / 2,
    );
  },
  methods: {
    handleTaskList(periodsId, item) {
      this.periodsId = periodsId;
      this.showTaskList = true;
      this.$webSeeSendTrack({
        event_id: 'study_task_list_click',
        event_type: 'click',
        data: {
          courseName: item.courseName,
          periodsId: item.periodsId,
          periodsName: item.periodsName,
        },
      });
    },
    async handlerCourseClick(index) {
      if (this.currentIndex !== index) {
        this.currentIndex = index;
        this.$emit('changeCourse', index);

        this.$webSeeSendTrack({
          event_id: 'my_courses_item_click',
          event_type: 'click',
          data: {
            course_id: this.list[index].course_id,
            course_title: this.list[index].title,
          },
        });
      }
    },
    navLeft() {
      if (this.navLeftIndex == 0) {
        return;
      }
      this.navLeftIndex--;
    },
    navRight() {
      if (this.navLeftIndex >= this.list.length - 1) {
        return;
      }
      this.navLeftIndex++;
    },
  },
};
</script>

<style lang="scss" scoped>
.ai-math-course-bar {
  padding: 16px 0;
  .list {
    // padding-bottom: 24px;
    position: relative;
    background: #fff;
    padding: 0 32px;
    .nav {
      // width: 16px;
      // height: 16px;
      position: absolute;
      top: 54px;
      z-index: 9;
      font-size: 16px;
      color: rgba(153, 153, 153, 0.9);
    }

    .nav-left {
      background-image: none;
      left: 16px;

      &:hover {
        color: rgba(51, 51, 51, 0.9);
      }
    }

    .nav-right {
      background-image: none;
      &:hover {
        color: rgba(51, 51, 51, 0.9);
      }

      right: 16px;
    }

    .item {
      width: 276px;
      height: 128px;
      margin-right: 24px;
      float: left;
      cursor: pointer;
      box-sizing: border-box;
      position: relative;

      &.selected {
        background-image: url(~@/modules/stu/images/member/rect-current@3x.png);
        background-repeat: no-repeat;
        border: none;
        background-size: 295px 145px;
        background-position: center -9px;

        .content {
          border: none;
        }
      }

      .last-viewed {
        position: absolute;
        top: 1px;
        right: 2px;
        display: inline-block;
        padding: 2px 4px;
        border-radius: 0px 3px 0px 4px;
        color: #f55;
        font-size: 10px;
        line-height: 14px;
        background: #ffefec;
      }
      .expire {
        position: absolute;
        width: 58px;
        top: 26px;
        right: 8px;
      }

      .content {
        padding: 17px 16px 0 16px;
        position: relative;
        border: 1px solid #e6e8eb;
        border-radius: 5px;
        height: 120px;
        box-sizing: border-box;
      }

      .title {
        display: flex;
        font-size: 16px;
        margin-bottom: 16px;
        line-height: 22px;
        position: relative;
        &-tag {
          font-size: 12px;
          color: #ff4242;
          font-weight: normal !important;
          padding: 4px 8px;
          width: 24px;
          height: 14px;
          line-height: 14px;
          background-color: #ffebeb;
          border-radius: 4px;
          text-align: center;
          margin-right: 8px;
        }
        .title-cont {
          font-weight: 500;
          flex: 1;
        }
      }

      .sub-title {
        display: flex;
        font-size: 14px;
        color: #35333a;
        line-height: 20px;
        align-items: center;

        &-content {
          max-width: 165px;
          overflow: hidden;
          text-overflow: ellipsis;
          word-break: break-all;
          -webkit-line-clamp: 1;
          white-space: nowrap;
        }

        .date {
          width: 70px;
        }
      }

      .line {
        margin: 0 8px;
        width: 1px;
        height: 10px;
        background-color: #35333a;
      }

      .valid {
        font-size: 14px;
        color: #1a1a1a;
        margin-top: 8px;
        line-height: 20px;
        .days {
          color: #ff2d28;
        }
      }
      .task-list-entry {
        margin-top: 8px;
        display: flex;
        align-items: center;
        height: 12px;
        width: 48px;
        padding: 4px;
        background-color: #f1f5ff;
        border-radius: 4px;
        color: #0060d1;
        font-size: 10px;
        line-height: 12px;
        &:hover {
          background-color: #bfcff8;
        }
      }
    }
  }
}
</style>
